export default __webpack_public_path__ + "static/media/bulk-blacklist-customers.ea988729.svg";